import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { NavTabs } from '@dreryk/react-components';

import { medicalLeaveTranslationKeys } from '../../translations';

import { GuardianMedicalLeaveTab } from './guardianMedicalLeave/GuardianMedicalLeaveTab';
import { HistoricalLeaves } from './historicalLeaves/HistoricalLeaves';
import { MedicalLeaveTab } from './medicalleave/MedicalLeaveTab';

type MedicalLeavePanelProps = {
   readonly visit: Visit;
};

export enum MedicalLeavePanelNavParams {
   LEAVE_FORM = 'pacjent',
   GUARDIAN_FORM = 'opiekun',
   LEAVES_HISTORY = 'historia-zwolnien',
}

export const MedicalLeavePanel = (props: MedicalLeavePanelProps): JSX.Element => {
   return (
      <NavTabs<MedicalLeavePanelNavParams> testId={'medicalLeave'}>
         <NavTabs.Tab
            testId={MedicalLeavePanelNavParams.LEAVE_FORM}
            param={MedicalLeavePanelNavParams.LEAVE_FORM}
            label={medicalLeaveTranslationKeys.tabs.medicalLeave}
            disabled={props.visit.patient.externalIdentifier!.accept<boolean>({
               visitPesel: () => false,
               visitGuardianPesel: () => true,
               visitPassport: () => false,
               visitNationalIdentificationNumber: () => false,
            })}
         >
            <MedicalLeaveTab visit={props.visit} />
         </NavTabs.Tab>
         <NavTabs.Tab
            testId={MedicalLeavePanelNavParams.GUARDIAN_FORM}
            param={MedicalLeavePanelNavParams.GUARDIAN_FORM}
            label={medicalLeaveTranslationKeys.tabs.guardianMedicalLeave}
            disabled={props.visit.patient.externalIdentifier!.accept<boolean>({
               visitPesel: () => false,
               visitGuardianPesel: () => false,
               visitPassport: () => false,
               visitNationalIdentificationNumber: () => false,
            })}
         >
            <GuardianMedicalLeaveTab visit={props.visit} />
         </NavTabs.Tab>
         <NavTabs.Tab
            testId={MedicalLeavePanelNavParams.LEAVES_HISTORY}
            param={MedicalLeavePanelNavParams.LEAVES_HISTORY}
            label={medicalLeaveTranslationKeys.tabs.historicalLeaves}
            disabled={props.visit.patient.externalIdentifier!.accept<boolean>({
               visitPesel: () => false,
               visitGuardianPesel: () => false,
               visitPassport: () => false,
               visitNationalIdentificationNumber: () => false,
            })}
         >
            <HistoricalLeaves patientId={props.visit.patient.id} />
         </NavTabs.Tab>
      </NavTabs>
   );
};
